import { render, staticRenderFns } from "./gj.vue?vue&type=template&id=d664d550"
import script from "./gj.vue?vue&type=script&lang=js"
export * from "./gj.vue?vue&type=script&lang=js"
import style0 from "./gj.vue?vue&type=style&index=0&id=d664d550&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports